import * as React from 'react';
import { useTranslation } from 'react-i18next';

import { AviaPassengerType } from '@websky/graphql';
import { Money } from '../../../Money';
import { Money as MoneyType } from '../../../Money/types';
import { getPassengerTypeLabel } from '../../../utils';

interface Price {
	type: AviaPassengerType;
	supplierType?: string;
	price: MoneyType;
}

interface Props {
	prices: Price[];
	isDifferentPrices?: boolean;
}

const PassengerPrices: React.FC<Props> = ({ prices, isDifferentPrices }) => {
	const { t } = useTranslation('Checkout');

	return (
		<div>
			{prices.map((passenger, index) => (
				<span key={`${passenger.type}-${index}`}>
					{getPassengerTypeLabel(passenger.type, passenger.supplierType)}: {isDifferentPrices && t('from')}
					<Money money={passenger.price} />
					{index < prices.length - 1 && <span>, </span>}
				</span>
			))}
		</div>
	);
};

export default PassengerPrices;
